import { getArtistsWithRolePlacement } from 'middleware/track/artistsWithRolePlacement';
import {
  IVideoMutation,
  IVideoMutationForm,
  TRACK_CENSORIOUS,
} from 'services/video/types';
import { unknownEnumValueConverter } from 'utils/global/valueConverter.utils';

export const videoFormToQuery = (
  videoForm: IVideoMutationForm
): IVideoMutation => {
  const { videoLink, originalVideoLink, file, canUpdateISRC, ...video } = {
    ...videoForm,
    source: 1,
    censorious: unknownEnumValueConverter<TRACK_CENSORIOUS>(
      videoForm.censorious
    ),
    genre: unknownEnumValueConverter<number>(videoForm.genre.id),
    artists: getArtistsWithRolePlacement(videoForm.artists),
    isrc: !!videoForm.isrc?.length ? videoForm.isrc?.replaceAll('-', '') : null,
    cline: videoForm.cline?.name?.length ? videoForm.cline : null,
    pline: videoForm.pline?.name?.length ? videoForm.pline : null,
    subtitles: !videoForm.isInstrumental ? videoForm.subtitles : [],
    contractRequests: videoForm.contracts.map(
      ({ contractId, divisionPercentage, startDate, endDate }) => ({
        contractId,
        divisionPercentage,
        startDate,
        endDate: endDate?.length ? endDate : null,
      })
    ),
  };

  return video;
};
